import React from 'react';
import { TextField, TextFieldProps } from '@material-ui/core';
import { PasswordOrnamentProps } from '../../../authentication/legos/textfield-ornaments';

export enum FactoryTextFields {
    TextField = 'TextField',
    TextFieldPassword = 'TextFieldPassword',
    ReadOnlyTextField = 'ReadOnlyTextField',
    MultiLineTextField = 'MultiLineTextField',
}

export type FactoryTextFieldTypes = keyof typeof FactoryTextFields;

type FactoryTextFieldProps = TextFieldProps & {
    id: string;
    label: string;
    placeHolder: string;
    dictionaryBase?: string;
    fieldClassName?: string;
    fieldType: FactoryTextFieldTypes;
    value: string;
    InputProps?: PasswordOrnamentProps;
};
export default function FactoryTextField(props: FactoryTextFieldProps) {
    const {
        id,
        dictionaryBase,
        fieldClassName,
        fieldType,
        InputProps,
        label,
        placeHolder,
        value,
        ...rest
    } = props;

    const multiline = fieldType === 'MultiLineTextField';
    const readOnly = fieldType === 'ReadOnlyTextField';

    return (
        <TextField
            className={fieldClassName}
            key={`${dictionaryBase}|${id}`}
            variant={readOnly ? 'standard' : 'outlined'}
            label={readOnly ? `${label} (read only)` : label}
            placeholder={placeHolder}
            disabled={readOnly}
            fullWidth
            defaultValue={value}
            multiline={multiline}
            minRows={multiline ? 3 : 1}
            InputProps={InputProps}
            {...rest}
        />
    );
}
